/** @jsxImportSource @emotion/react */

import React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

function YoutubeIcon(props: IProps) {
  const { width = 36, height = 36, ...rest } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M15.1429 22.2857L22.5572 18L15.1429 13.7143V22.2857ZM31.6572 11.1C31.8429 11.7714 31.9715 12.6714 32.0572 13.8143C32.1572 14.9571 32.2001 15.9429 32.2001 16.8L32.2858 18C32.2858 21.1286 32.0572 23.4286 31.6572 24.9C31.3001 26.1857 30.4715 27.0143 29.1858 27.3714C28.5144 27.5571 27.2858 27.6857 25.4001 27.7714C23.5429 27.8714 21.8429 27.9143 20.2715 27.9143L18.0001 28C12.0144 28 8.28578 27.7714 6.81436 27.3714C5.52864 27.0143 4.70007 26.1857 4.34293 24.9C4.15721 24.2286 4.02864 23.3286 3.94293 22.1857C3.84293 21.0429 3.80007 20.0571 3.80007 19.2L3.71436 18C3.71436 14.8714 3.94293 12.5714 4.34293 11.1C4.70007 9.81429 5.52864 8.98571 6.81436 8.62857C7.48578 8.44286 8.71436 8.31429 10.6001 8.22857C12.4572 8.12857 14.1572 8.08571 15.7286 8.08571L18.0001 8C23.9858 8 27.7144 8.22857 29.1858 8.62857C30.4715 8.98571 31.3001 9.81429 31.6572 11.1Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default YoutubeIcon;
